/* eslint-disable no-console */
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { inject } from 'alfa';
import { withRouter } from 'react-router-dom';

import BusinessRepo from '../../repository/business';
import { LoadingBlock } from '../loading';
import CustomFirebase from '../../helpers/custom-firebase';

const BusinessLoader = ({ business: businessFromProps, set, ...props }) => {
  console.debug('[SESSION: Business loader]');

  const params = new URLSearchParams(window.location.search);
  const slug = params.get('bizslug');
  const shouldLoad = (biz, entitySlug) => !biz || (entitySlug && biz.slug !== entitySlug);

  const [businesses, setBusinesses] = useState([]);
  const [business, setBusiness] = useState(null);
  const [loading, setLoading] = useState(shouldLoad(businessFromProps, slug));
  const loadBusinesses = useCallback(async () => {
    try {
      const { data: { businesses: bizes } } = await BusinessRepo.all();
      const currentBiz = bizes.find((b) => b.slug === slug);
      const biz = currentBiz || bizes[0];
      setBusiness(biz);
      setBusinesses(bizes);
      CustomFirebase.setBusiness(biz);
    } catch (error) {
      console.error('ERROR: BusinessLoader: BusinessRepo.all()', error);
    } finally {
      setLoading(false);
    }
  }, [slug]);

  useEffect(() => {
    if (!shouldLoad(business, slug)) {
      return;
    }

    console.debug('[SESSION: Loading business]');
    loadBusinesses();
  }, [business, slug, loadBusinesses]);


  if (loading) {
    return <LoadingBlock />;
  }

  set('businesses', businesses);
  set('business', business);

  return props.children;
};

BusinessLoader.propTypes = {
  business: PropTypes.shape({
    slug: PropTypes.string,
  }),
  children: PropTypes.node,
  set: PropTypes.func,
};

export default inject(withRouter(BusinessLoader), ['set', 'businesses', 'business'], ['businesses', 'business']);
